import './support-services.scss';
import React, { useLayoutEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { Trans, useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router';

import * as images from './support-services-media'
import StopMotionSvg from '../../components/StopMotionSvg';
import DashedDrawedSvg from '../../components/DashedDrawedSvg';
import CommonButton from '../../components/button/button';
import useDeviceDetection from '../../hooks/useDeviceDetection';


function SupportServices() {

    const { reloadState, relativeVh } = useOutletContext();

    const { t } = useTranslation();
    const [isRtl, setIsRtl] = useState(1);
    const [intervalSection2, setIntervalSection2] = useState(null);
    const [intervalSection6, setIntervalSection6] = useState(null);
    const [intervalSection10b, setIntervalSection10b] = useState(null);
    const dotsRefs = useRef([]);
    const deviceType = useDeviceDetection();

    useLayoutEffect(() => {
        window.scrollTo({ top: 0 });
        reloadState[1](false);
    }, []);

    useGSAP((context) => {

        //#region section 1

        gsap.to('#support-services-header', {
            scrollTrigger: {
                trigger: '#section1',
                start: 'top top',
                end: 'bottom top',
                scrub: true,
            },
            scale: 0.21
        });
        //#endregion

        //#region section 2
        const tl = gsap.timeline();
        ScrollTrigger.create({
            animation: tl,
            trigger: '.section-2',
            start: "top 70%",
            end: '10% 20%',
            scrub: true
        });
        tl.fromTo(".section-2 .row .item",
            {
                autoAlpha: 0,
                y: 100,
            },
            {
                autoAlpha: 1,
                y: 0,
                duration: 1,
                stagger: .35
            }
        )
            .add(() => setIntervalSection2(i => !i ? 400 : null), '-=0.2')
        //#endregion

        //#region section 4

        // bubbles entering
        const tl4 = gsap.timeline();

        ScrollTrigger.create({
            animation: tl4,
            trigger: '.section-4',
            start: "top 70%",
            end: '30% top',
            scrub: true
        });

        tl4.fromTo(".section-4 .bubles-container .bubble",
            {
                autoAlpha: 0.6,
                y: 100,
            },
            {
                autoAlpha: 1,
                y: 0,
                duration: 4,
                stagger: .55,
                ease: "back.out"
            }
        )

        //#region  paralax
        // const paralaxTlSection4 = gsap.timeline({
        //     scrollTrigger: {
        //         trigger: "#section4",
        //         start: "top 20%", // Start pinning when the top of the element hits the top of the viewport
        //         end: `+=${350 * relativeVh}`,    // Optional: Keep space for smooth scroll
        //         pin: true,        // Pin the container
        //         scrub: 1,     // Do not scrub; time-based behavior
        //     }
        // });

        // // Add a delay to simulate time-based pinning
        // paralaxTlSection4.to("#section4", { duration: 3, ease: 'power1.out' }); // Pinned for 3 seconds

        // Optionally fade out or slide away after the pinning time
        //   paralaxTlSection4.to("#section4", { opacity: 0, duration: 1 }, "+=0.5"); // Add 0.5s delay before fading

        //#endregion
        //#endregion

        //#region section 6
        gsap.fromTo(".section-6 .bubble",
            {
                autoAlpha: 0.6,
                y: 50,
            },
            {
                autoAlpha: 1,
                y: 0,
                ease: "back.out",
                scrollTrigger: {
                    trigger: '#section6',
                    start: 'center bottom',
                    end: 'bottom bottom',
                    scrub: 1,
                },
            });
        //#endregion

        //#region section 8 

        if (!deviceType?.isMobile) {
            // green header entering
            gsap.from('.section-8 .marked-text', {
                scrollTrigger: {
                    trigger: '.section-8 .marked-text',
                    start: 'top bottom',
                    endTrigger: '.section-7',
                    end: 'top 10%',
                    scrub: true,
                },
                scale: (130 / 88),
                ease: 'power1.out',
            });
        }

        // dots loading animation
        const tlDots = gsap.timeline({ repeat: -1, duration: 2 })


        //#endregion

        //#region section 10

        ScrollTrigger.create({
            onEnter: () => setIntervalSection10b(400), onLeave: () => setIntervalSection10b(null),
            onEnterBack: () => setIntervalSection10b(400), onLeaveBack: () => setIntervalSection10b(null),
            trigger: '.s-10-b', start: '30% center', end: 'bottom top'
        }
        );

        //#region - section 12 white svg entering
        gsap.from('div.s-10-d svg', {
            scrollTrigger: {
                trigger: 'div.s-10-d svg',
                start: '20% bottom',
                end: 'center center',
                scrub: 0.5,
            },
            xPercent: 100,
            opacity: 0,
        });
        //#endregion

        //#endregion

        //#region section 13 -  prouductions row go up on e after onother

        const boxesTl = gsap.timeline();

        ScrollTrigger.create({
            animation: boxesTl,
            trigger: '.section-13',
            endTrigger: '.section-13 .sub-title',
            start: "top 70%",
            end: 'top 20%',
            scrub: 0.2
        });

        boxesTl.fromTo(".section-13 .productions .box",
            {
                autoAlpha: 0,
                y: 30,
            },
            {
                autoAlpha: 1,
                y: 0,
                stagger: .6,
                ease: 'power1.out'
            }
        )

        //#endregion


        //#region dancing items



        if (!deviceType?.isMobile) {
            dotsRefs.current.forEach((dot, index) => {
                tlDots
                    .set(dot, {
                        scale: 1, // Start all dots at normal size
                        backgroundColor: 'var(--purple)',
                        margin: 0
                    }) // Initially set all to normal size
                    .to(dot, {
                        scale: 1.8, // The larger size
                        backgroundColor: '#D9D9D9',
                        margin: '0 18px',
                        duration: 0, // Instant transition for stop-motion effect
                    }, index * 1) // Each dot gets big one after the other
                    .set(dot, {
                        scale: 1, // Return to normal size immediately after being large
                        backgroundColor: 'var(--purple)',
                        margin: 0
                    }, (index + 1) * 1); // Keep the next dot small after the previous one goes small
            });

            //section 4 text
            gsap.timeline({ repeat: -1 })
                .set('#section4 .head-sub', { rotate: -10, x: 0, y: 0 }, 0)
                .set('#section4 .head-sub', { rotate: -15, x: 'calc((5) * var(--vw))', y: 'calc((6) * var(--vw))' }, 0.6)
                .set('#section4 .head-sub', { rotate: -20, x: 10, y: 16 }, 1.2)
                .set('#section4 .head-sub', { rotate: -15, x: 'calc((5) * var(--vw))', y: 'calc((6) * var(--vw))' }, 1.8)
                .set('#section4 .head-sub', { rotate: -10, x: 0, y: 0 }, 2.4);


            //section 6 text
            const textS6TL = gsap.timeline({ repeat: -1, paused: false })
                .set('#section6 .head-sub', { rotate: 0, x: 0, y: 0 }, 0)
                .set('#section6 .head-sub', { rotate: 3, x: 'calc((5) * var(--vw))', y: 'calc((6) * var(--vw))' }, 0.4)
                .set('#section6 .head-sub', { rotate: 0, x: 10, y: 16 }, 0.8)
                .set('#section6 .head-sub', { rotate: 3, x: 'calc((5) * var(--vw))', y: 'calc((6) * var(--vw))' }, 1.2)
                .set('#section6 .head-sub', { rotate: 0, x: 0, y: 0 }, 1.6);

            ScrollTrigger.create({
                onEnter: () => { textS6TL.play(); setIntervalSection6(800) },
                onLeave: () => { textS6TL.pause(); setIntervalSection6(null) },
                onEnterBack: () => { textS6TL.play(); setIntervalSection6(800) },
                onLeaveBack: () => { textS6TL.pause(); setIntervalSection6(null) },
                trigger: '#section6', start: 'bottom bottom', end: 'bottom top'
            }
            );

            // section 10 C img dancing
            gsap.timeline({ repeat: -1 })
                .set('div.s-10-c img', { rotate: 0 }, 0)
                .set('div.s-10-c img', { rotate: -10.42 }, 0.8)
                .set('div.s-10-c img', { rotate: 0 }, 1.6);
        }
        else gsap.set(dotsRefs.current.at(0), {
            scale: 1.8, // The larger size
            backgroundColor: '#D9D9D9',
            margin: '0 18px',
            duration: 0, // Instant transition for stop-motion effect
        }) // Each dot gets big one after the other


        // section 14
        gsap.timeline({ repeat: -1 })
            .set('.section-14-images div img', { x: -24 }, 0)
            .set('.section-14-images div img', { x: 24 }, 0.9)
            .set('.section-14-images div img', { x: -24 }, 1.8)

        //#endregion


        setTimeout(() => {
            // Ensure ScrollTrigger recalculates positions
            ScrollTrigger.refresh();
        }, 100);

        return () => {
            context.kill();
        }
    }, { dependencies: [relativeVh, deviceType] })

    return (
        <div className='support-services-component'>
            {/* section 1 */}
            <section id="section-1">
                <h1 id="support-services-header" className='headline'>
                    <Trans i18nKey={'support-services.opration and support services'}>
                        <span className='intro-title'></span>
                    </Trans>
                </h1>
            </section>

            {/* section 2 */}
            <section className='section-2' id="section2">
                <div className='sub-title'>
                    <Trans i18nKey="support-services.How do we ensure that your online learning works excellently">
                        How do we ensure that your online learning works <span className='marked-text'>excellently</span>
                    </Trans>
                </div>
                <div className='productions-types' id='productions-types'>
                    <div className="row">
                        {images.section2Images.map((item, index) => (
                            <div className="item" key={`item${index}`}>
                                <div className='dancing-lines-container' style={{
                                    marginInline: item.marginInline,
                                    marginBlock: item.marginBlock,
                                    ...(item.justifyContent && { justifyContent: item.justifyContent })
                                }}>
                                    <StopMotionSvg
                                        shapes={item.shapes}
                                        width={item.width}
                                        height={item.height}
                                        interval={intervalSection2}
                                    />
                                </div>
                                <div className={`related-image ${item.name}`}>
                                    <img src={item.img} alt={t(`support-services.section-2.${item.description}`)} />
                                </div>
                                <p className={`${item.name}-p text-run`}>{t(`support-services.section-2.${item.description}`)}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* section 3 */}
            {deviceType?.isMobile ? (
                <div className="mobile-dash-line" id="mobile-dash-line-1">
                    <DashedDrawedSvg
                        svgWidth="205" svgHeight="207"
                        d="M95.125 2.96629C82.2462 13.1621 46.2525 128.22 85.2425 118.444C174.361 96.099 58.933 212.288 116.647 199.907"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-1' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            ) : (
                <section className='section-3' id="section3">
                    <div className='transition-1' id="transition-1">
                        <DashedDrawedSvg svgWidth='305' svgHeight='262' strokeDasharray='940'
                            d='M5 23.7493C66.1959 -70.875 67.224 241.793 157.364 91.3253C196.801 25.4943 303.532 229.404 299.91 260.553'
                            trigger='#section3' startTrigger="top 85%" endTrigger="bottom 10%" />
                    </div>
                </section>
            )}

            {/* section 4 */}
            <section className='section-4' id="section4">
                {deviceType?.isMobile && <h2 className='head-sub'>{t('support-services.section-4.The learners')}</h2>}
                <div className='bubles-container'>
                    {!deviceType?.isMobile && <h2 className='head-sub'>{t('support-services.section-4.The learners')}</h2>}
                    {images?.talkBubblesSection4.map((bubble, i) => (
                        <div className='bubble' key={`bubble${i}`}>
                            {bubble.bubble}
                            <p className='talk-bubble' id={`bubble-${i}`}>{t(`support-services.section-4.${bubble.text}`)}</p>
                        </div>
                    ))}
                </div>
                <img src={images.leranersSection4} alt='' />
            </section>

            {/* section 5 */}
            {deviceType?.isMobile ? (
                <div className="mobile-dash-line" id="mobile-dash-line-2">
                    <DashedDrawedSvg
                        svgWidth="201" svgHeight="166"
                        d="M145.187 6.23021C221.72 92.0196 26.3217 -9.51468 144.023 118.786C195.519 174.918 81.3461 151.829 65.3636 142.293"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-2' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            ) : (
                <section className='section-5' id="section5">
                    <div className='transition-2'>
                        <DashedDrawedSvg d='M152.072 3.60789C250.119 113.513 -0.205838 -16.5629 150.582 147.803C216.553 219.715 70.2861 190.134 49.8109 177.918'
                            strokeDasharray='540' svgWidth='241' svgHeight='212'
                            trigger='#section5' startTrigger="top 70%" endTrigger="bottom 5%" />
                    </div>
                </section>
            )}

            {/* section 6 */}
            {deviceType?.isMobile ?
                <section className='section-6' id="section6">
                    <h6 className={'head-sub'}>{t('support-services.section-5-6-7.You')}</h6>
                    <div className='flex'>
                        <div className='flex-column'>
                            <div className='bubble'>
                                {images.talkBubbles.orange}
                                <p className='talk-bubble'>
                                    {t(`support-services.section-5-6-7.I dont have time to answer everyone`)}
                                </p>
                            </div>
                            <div className='bottom-row-container flex'>

                                <div className='flex-column'>
                                    <img src={images.youSection6} alt='' />
                                    <div className='bench'></div>

                                </div>
                            </div>
                        </div>
                        <StopMotionSvg
                            shapes={images.decorateLinesSection6}
                            width={186}
                            height={363}
                            interval={intervalSection6}
                        />
                    </div>

                </section> :
                <section className='section-6' id="section6">
                    <div className='flex-column'>
                        <div className='bubble'>
                            {images.talkBubbles.orange}
                            <p className='talk-bubble'>
                                {t(`support-services.section-5-6-7.I dont have time to answer everyone`)}
                            </p>
                        </div>
                        <div className='bottom-row-container flex'>
                            <h6 className={'head-sub'}>{t('support-services.section-5-6-7.You')}</h6>

                            <div className='flex-column'>
                                <img src={images.youSection6} alt='' />
                                <div className='bench'></div>

                            </div>
                        </div>
                    </div>
                    <StopMotionSvg
                        shapes={images.decorateLinesSection6}
                        width={186}
                        height={363}
                        interval={intervalSection6}
                    />

                </section>}

            {/* section 7 */}
            {deviceType?.isMobile ? (
                <div className="mobile-dash-line" id="mobile-dash-line-3">
                    <DashedDrawedSvg
                        svgWidth="201" svgHeight="166"
                        d="M110.5 17.9248C93.8385 24.683 28.4305 33.0021 93.0001 73.4248C168.677 120.801 18.4995 109.925 119.049 152.425"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-3' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            ) : (
                <section className='section-7' id="section7">
                    <div className='transition-7'>
                        <DashedDrawedSvg d='M73.5292 4.81868C-22.864 25.319 172.777 68.4971 26.0937 97.0683C-38.0817 109.569 60.6697 164.257 77.2006 166.788'
                            strokeDasharray='340' svgWidth="88" svgHeight="172" diffrentTriggerEnd='#section7'
                            trigger='.transition-7' startTrigger="top 80%" endTrigger="bottom 30%" />
                    </div>
                </section>
            )}

            {/* section 8 */}
            <section className='section-8' id="section8">
                <div>
                    <p className={'head-sub'}>{t('support-services.section-5-6-7.We')}</p>
                    <p className={'text-run'}>{t('support-services.section-5-6-7.Nice to meet you')}</p>
                    <p className={'marked-text'}>{t('support-services.section-5-6-7.Operations and support')}</p>
                </div>
                <div className='flex'>
                    <div className='loading-dots'>
                        {['Span 1', 'Span 2', 'Span 3'].map((text, index) => (
                            <span key={index} ref={el => dotsRefs.current[index] = el} className='dot'></span>
                        ))}
                    </div>
                    <img src={images.section8Image} alt='' />
                </div>
            </section>
            {deviceType?.isMobile && (
                <div className="mobile-dash-line" id="mobile-dash-line-4">
                    <DashedDrawedSvg
                        svgWidth="243" svgHeight="202"
                        d="M29.9009 4.6047C47.8623 5.87383 192.969 60.8165 144.576 82.6144C33.9663 132.437 259.171 163.282 188.131 198.088"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-4' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            )}

            {/* section 9 */}
            <section className='section-9' id="section9">
                <p className='sub-title'>
                    <Trans i18nKey="support-services.Wait is it operations or support"><span className='marked-text'></span></Trans>
                </p>
                <p className={'sub-title'}>{t('support-services.Its actually a team that does everything')}</p>
                <img src={images.section9Img} alt='' />
                <p className={'sub-title m-t-100'}>{t('support-services.The team will accompany and operate your course')}</p>
            </section>
            {deviceType?.isMobile && (
                <div className="mobile-dash-line" id="mobile-dash-line-5">
                    <DashedDrawedSvg
                        svgWidth="195" svgHeight="164"
                        d="M13.5291 15.9228C38.9565 -37.3468 60.5137 125.007 97.222 40.7823C113.282 3.93307 182.437 102.682 182.65 119.107"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-5' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            )}

            {/* section 10 */}
            <section className='section-10' id="section10">
                <div className='flex s-10-a'>
                    <div className='flex-column'>
                        <p className={'text-run'}>{t('support-services.Will take care of everything')}</p>
                        <img src={images.section10Img1} alt='' />
                    </div>
                    {!deviceType?.isMobile && (<DashedDrawedSvg d='M29.585 4.67788C-85.6066 59.7467 247.483 101.947 69.1202 180.98C-8.91516 215.558 197.738 296.593 224.574 298.13'
                        strokeDasharray='740' svgWidth="225" svgHeight="303"
                        trigger='#section10 .flex svg' startTrigger="top 80%" endTrigger="bottom 30%" />)}
                </div>
                {deviceType?.isMobile &&
                    <div className="mobile-dash-line" id="mobile-dash-line-6">
                        <DashedDrawedSvg
                            svgWidth="177" svgHeight="161"
                            d="M29.6617 4.9076C43.7496 10.1097 187.614 98.4095 153.186 102.94C74.4966 113.294 175.892 148.144 125.746 156.858"
                            strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                            trigger='#mobile-dash-line-6' startTrigger="top 85%" endTrigger="bottom 10%" />
                    </div>

                }
                <div className='flex-column  s-10-b'>
                    <p className={'text-run'}>{t('support-services.Will lead the learners')}</p>
                    <div className='flex'>
                        <StopMotionSvg shapes={images.bigOrangeLineDancingPathes} width={144} height={278} interval={intervalSection10b} />
                        <img src={images.section10Img2} alt='' />
                        {images.gridBoardSvg}
                    </div>
                </div>
                {deviceType?.isMobile && (
                    <div className="mobile-dash-line" id="mobile-dash-line-7">
                        <DashedDrawedSvg
                            svgWidth="201" svgHeight="195"
                            d="M68.027 0.486351C58.0894 13.5654 51.8493 133.96 87.1817 114.792C167.94 70.9804 85.0444 212.231 137.864 185.882"
                            strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                            trigger='#mobile-dash-line-7' startTrigger="top 85%" endTrigger="bottom 10%" />
                    </div>
                )}
                <div className='flex s-10-c'>
                    <div className='flex-column'>
                        <p className={'text-run'}>{t('support-services.Will operate without issues from room splitting to recordings')}</p>
                        <img src={images.section10Img3} alt='' />
                    </div>
                </div>
                {deviceType?.isMobile && (
                    <div className="mobile-dash-line" id="mobile-dash-line-8">
                        <DashedDrawedSvg
                            svgWidth="195" svgHeight="202"
                            d="M181.472 54.3115C156.044 1.04189 134.487 163.396 97.779 79.1709C81.7187 42.3217 12.5643 141.071 12.3514 157.496"
                            strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                            trigger='#mobile-dash-line-8' startTrigger="top 85%" endTrigger="bottom 10%" />
                    </div>
                )}
                <div className='flex-column s-10-d'>
                    <p className={'text-run'}>{t('support-services.To ensure your learners complete successfully and you focus on teaching')}</p>
                    <img src={images.section10Img4} alt='' />
                    {images.whiteLine}
                </div>

            </section>
            {deviceType?.isMobile && (
                <div className="mobile-dash-line" id="mobile-dash-line-9">
                    <DashedDrawedSvg
                        svgWidth="201" svgHeight="196"
                        d="M68.028 2.28762C58.0904 15.3667 51.8502 135.761 87.1827 116.593C167.941 72.7817 85.0454 214.033 137.865 187.683"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-9' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            )}
            {/* section 13 */}
            <section className='section-13' id='section13'>
                <div className='sub-title'>
                    <Trans i18nKey="support-services.Who is on the operations and support team">
                        מי בצוות <span className='marked-text'>תמיכה ותפעול</span> ?
                    </Trans>
                </div>
                <div className='productions'>
                    {images.whoIsInTheSupportTeamBoxes.map((item, index) => (
                        <div className="box" key={`item${index}`}>
                            {item.svgElement}
                            <span>{t(`support-services.support-emploeeies-types.${item.description}`)}</span>
                        </div>
                    ))}
                </div>
            </section>
            {deviceType?.isMobile && (
                <div className="mobile-dash-line" id="mobile-dash-line-10">
                    <DashedDrawedSvg
                        svgWidth="195" svgHeight="201"
                        d="M181.472 53.6313C156.044 0.361719 134.487 162.716 97.779 78.4907C81.7187 41.6416 12.5643 140.391 12.3514 156.816"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-10' startTrigger="top 85%" endTrigger="bottom 10%" />
                </div>
            )}

            {/* section 14 */}
            <section className='section-14' id='section14'>
                <div className='yalla'>
                    <div className='sub-title'>
                        <Trans i18nKey="support-services.In short you focus on the content and we will take care of the rest">
                            In short you focus on the content and we will <span className='marked-text'>take care</span> of the rest
                        </Trans>
                    </div>
                    <div className='flex'>
                        <CommonButton text={t("support-services.Support me")} routePath='/contact-us' containerPage="support services" />
                        {images.section14Decorations.lines}
                    </div>
                </div>
                <div className='section-14-images'>
                    <div>
                        <img src={images.section14Decorations.image} alt='' />
                        {images.section14Decorations.greenSvg}
                    </div>
                    <img src={images.section14Decorations.tringles} alt='' />
                </div>
            </section>
        </div>
    );
};



export default SupportServices;

